import { render, staticRenderFns } from "./pageGrb.vue?vue&type=template&id=b1a75dce&"
import script from "./pageGrb.vue?vue&type=script&lang=js&"
export * from "./pageGrb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports